var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import { withStyles } from "@material-ui/core";
import clsx from "clsx";
var styles = {
    root: {
        display: "block",
        width: "100%",
        minHeight: 150,
        margin: "0 10px 10px 0",
        position: "relative"
    },
    content: {},
    "empty-slot": {},
    "populated-slot": {}
};
var InlineChooser = function (props) {
    var _a;
    var classes = props.classes, children = props.children, className = props.className, _b = props.variant, variant = _b === void 0 ? "empty" : _b, aspectRatio = props.aspectRatio, other = __rest(props, ["classes", "children", "className", "variant", "aspectRatio"]);
    var aspectRatioPaddingTop = React.useMemo(function () {
        if (!aspectRatio) {
            return undefined;
        }
        var components = aspectRatio.split(':');
        if (components.length !== 2) {
            return undefined;
        }
        return Math.round(Number(components[1]) / Number(components[0]) * 100) + '%';
    }, [aspectRatio]);
    return (React.createElement("div", __assign({}, other, { className: clsx(classes.root, (_a = {},
            _a[classes["empty-slot"]] = variant === "empty-slot",
            _a[classes["populated-slot"]] = variant === "populated-slot",
            _a), className) }), aspectRatio ? (React.createElement(React.Fragment, null,
        React.createElement("div", { style: { display: 'block', paddingTop: aspectRatioPaddingTop } }, "\u00A0"),
        React.createElement("div", { className: clsx(classes.content) }, children))) : (React.createElement("div", { className: clsx(classes.content) }, children))));
};
export default withStyles(styles)(InlineChooser);
